import { Slide } from '@/components/core/Slide';
import audioFile from './26-ai-automation.mp3';

const transcript = `
AI-automation is de lijm tussen traditionele automatisering en handwerk. 
Waar oude software rigide is, is generatieve AI flexibel, autonoom en 
zelflerend in de juiste setup. Dit maakt het tot een van de beste 
investeringen voor je bedrijf. Veel taken zijn repetitief, soms saai 
of zelfs uitdagend, en vaak hebben ze geen raakvlak met wat je echt 
belangrijk vindt of wat de kern is van je toegevoegde waarde.

AI-automation kan die taken aanzienlijk versnellen of zelfs volledig 
overnemen. En het enige dat echt onbetaalbaar is, als ik naar jullie 
mensen kijk, is tijd. Werk met mij, en werk aan je toekomst.
`;

// Jonathan: En heb je nog ideen over de toekomst?

export const slide = () => {
  return (
    <Slide
      notes={transcript}
      audio={audioFile}
      visualizer="full"
      transition="fade"
      networkBackground="full"
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
